export enum LoginType {
  Direct = "Direct",
  SingleSignOn = "SSO"
}